import React, { Component } from 'react';
import PropTypes from 'prop-types';
import History from '../history';
// import { analyticsCheckoutEvent } from '../util/analyticEvents';

class AvardaCheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.iteration = 0;
    this.waitUntilAvardaScriptIsLoaded = this.waitUntilAvardaScriptIsLoaded.bind(this);
  }

  componentDidMount() {
    if (this.props.avardaSessionId) {
      this.initializeAvardaSession();
    }
  }

  shouldComponentUpdate(nextProps) {
    return (
      (nextProps.avardaSessionId && nextProps.avardaSessionId !== this.props.avardaSessionId) ||
      (nextProps.deliveryMethodId && nextProps.deliveryMethodId !== this.props.deliveryMethodId)
    );
  }

  componentDidUpdate() {
    if (this.props.avardaSessionId) {
      // clear old iframe when a new on is initialized
      document.getElementById('checkOutDiv').innerHTML = '';
      this.initializeAvardaSession();
    }
  }

  initializeAvardaSession() {
    this.waitUntilAvardaScriptIsLoaded();
  }

  waitUntilAvardaScriptIsLoaded() {
    const { deliveryMethodId } = this.props;

    if (typeof window.AvardaCheckOutClient !== 'undefined') {
      const callbackUrl = `${window.location.origin}/kassa?purchaseId=${this.props.avardaSessionId}&deliveryMethodId=${
        this.props.deliveryMethodId
      }&serverSideCallbackUrl=${this.props.serverSideCallbackUrl}`;

      const options = {
        // ID of the <div> inside which to render the form
        divId: 'checkOutDiv',
        // The Purchase ID obtained in the previous step
        purchaseId: this.props.avardaSessionId,
        purchaseCompletedCallbackUrl: this.props.serverSideCallbackUrl,
        callbackUrl,
        done(purchaseId) {
          window.location.href = `/kassa?purchaseId=${purchaseId}&deliveryMethodId=${deliveryMethodId}&callback=1`;
        },
        customCssUrl: `${window.location.origin}/avardaStyles.css`,
        replaceDefaultCss: true
      };

      window.AvardaCheckOutClient.init(options);
      return true;
    }

    this.iteration = this.iteration + 1;

    if (this.iteration > 10) {
      History.push('/error');
    } else {
      setTimeout(() => {
        this.waitUntilAvardaScriptIsLoaded();
      }, 500);
    }

    return false;
  }

  render() {
    return <div id="checkOutDiv" />;
  }
}

AvardaCheckoutForm.defaultProps = {
  avardaSessionId: undefined,
  deliveryMethodId: undefined,
  serverSideCallbackUrl: undefined
};

AvardaCheckoutForm.propTypes = {
  avardaSessionId: PropTypes.string,
  deliveryMethodId: PropTypes.string,
  serverSideCallbackUrl: PropTypes.string
};

export default AvardaCheckoutForm;



// WEBPACK FOOTER //
// ./src/components/AvardaCheckoutForm.js